export default "__VITE_ASSET__CHhmazJe__"